
export enum PayPeriodStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  SENT = 'SENT',
  PAID = 'PAID'
}

export interface User {
  id: string;
  email: string;
  name: string;
  hourlyRate: number;
  webhookUrl?: string;
  largeTextMode?: boolean;
  autoMarkPaid?: boolean;
}

export interface Client {
  id: string;
  userId: string;
  name: string;
  email?: string;
  defaultRate: number;
  notes?: string;
  createdAt: string;
}

export interface Project {
  id: string;
  clientId: string;
  name: string;
  notes?: string;
}

export interface TimeEntry {
  id: string;
  userId: string;
  clientId: string;
  projectId?: string;
  payPeriodId?: string;
  date: string;
  timeIn: string; // HH:mm
  timeOut: string; // HH:mm
  notes: string;
  billable: boolean;
  hoursCalculated: number;
  amountCalculated: number;
}

export interface PayPeriod {
  id: string;
  userId: string;
  clientId: string;
  startDate: string;
  endDate: string;
  rateSnapshot: number;
  status: PayPeriodStatus;
  totalHours: number;
  totalAmount: number;
  sentAt?: string;
  paidAt?: string;
}

export interface WebhookPayload {
  worker: {
    name: string;
    email: string;
  };
  client: {
    name: string;
    email: string;
  };
  payPeriod: {
    startDate: string;
    endDate: string;
    totalHours: number;
    rate: number;
    totalAmount: number;
    daysWorked: number;
    status: string;
  };
  entries: TimeEntry[];
  isPreview: boolean;
}
